import { Analytics } from '@simple-life-app/simple-growth-frontend-tools'
import { useMainStore } from '@/store/main'
import { useLocationStore } from '@/store/location'
import { useSurveyStore } from '@/store/survey'

let analyticInstance = null
export const getAnalytic = () => analyticInstance

export default {
	install: (app, { options, router }) => {
		const analytic = new Analytics(options)

		const mainStore = useMainStore()

		// Проверяем превью мод один раз при инициализации
		const isPreviewMode = mainStore.isPreviewMode

		// Регистрируем router hook только если не превью мод
		if (!isPreviewMode) {
			router.beforeEach((to) => {
				const hasAnalyticData = Boolean(to.meta.pageAnalyticUxEvent)

				if (hasAnalyticData && !Boolean(to.query.popup)) {
					const { name, data } = to.meta.pageAnalyticUxEvent

					analytic.logEvent(name, data)
				}
			})
		}

		// Создаем методы аналитики с учетом превью мода
		const createAnalyticMethod = (originalMethod) => {
			return isPreviewMode ? () => Promise.resolve() : originalMethod
		}

		const analyticApi = {
			logEvent: createAnalyticMethod((eventName, eventProperties) => {
				const locationStore = useLocationStore()
				const { funnel } = locationStore.getAppAreaConfig
				const initialFunnelType = locationStore.getInitialFunnelType

				return analytic.logEvent(eventName, {
					url: window.location.href,
					initial_funnel_type: initialFunnelType,
					funnel_type: funnel.slug,
					funnel_id: funnel.id,
					...eventProperties,
				})
			}),
			setUserProperties: createAnalyticMethod((...args) => {
				const surveyStore = useSurveyStore()
				// Note: этот метод можно будет перенести в Jet после отказа от Amplitude
				surveyStore.handleUserAnalyticData(...args)
				return analytic.setUserProperties(...args)
			}),
			initDestinationPlugins: (...args) => analytic.initDestinationPlugins(...args),
			setUserId: (...args) => analytic.setUserId(...args),
		}

		analyticInstance = analyticApi
		app.config.globalProperties.$analytic = analyticApi
	},
}
